module.exports = __webpack_public_path__ + "static/media/29EUNOG5.dc6b83aa.jpg";